import { render, staticRenderFns } from "./plan_envmt_page.vue?vue&type=template&id=2f3eda8e&scoped=true"
import script from "./plan_envmt_page.vue?vue&type=script&lang=js"
export * from "./plan_envmt_page.vue?vue&type=script&lang=js"
import style0 from "./plan_envmt_page.vue?vue&type=style&index=0&id=2f3eda8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3eda8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3eda8e')) {
      api.createRecord('2f3eda8e', component.options)
    } else {
      api.reload('2f3eda8e', component.options)
    }
    module.hot.accept("./plan_envmt_page.vue?vue&type=template&id=2f3eda8e&scoped=true", function () {
      api.rerender('2f3eda8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grow/plan_envmt_page.vue"
export default component.exports